import React from 'react'
import InlineIcon from '../InlineIcon/InlineIcon.jsx'
import './AppLoadError.scss'

function AppLoadError() {
  return (
    <div className='app-load-error' role='alert'>
      <h1 className='app-load-error__title'>
        <InlineIcon name='alert-circle' className='app-load-error__icon' />
        Oops! Something went wrong.
      </h1>
      <p className='app-load-error__hint'>
        Check your Internet connection and the URL in the address bar.
      </p>
    </div>
  )
}

export default AppLoadError
